import React from 'react';
import { useParams, useNavigate} from "react-router-dom";
import Book from "./Book"

export default function PageBook() {
  let params = useParams();
  let navigate = useNavigate();
    return <Book bookKey={params.bookKey} navigate={navigate} />
  }